import { render } from "./LayoutSettings.vue?vue&type=template&id=57c71fb7"
import script from "./LayoutSettings.vue?vue&type=script&lang=js"
export * from "./LayoutSettings.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__